var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "fadeHubHeaderItem", mode: "out-in", appear: "" } },
    [
      !_vm.loading && _vm.show
        ? _c(
            "v-card",
            {
              staticClass: "hub-header-item-text-container",
              attrs: {
                to:
                  !_vm.route || _vm.disabled || _vm.redirect === true
                    ? undefined
                    : _vm.route,
                ripple: "",
                hover: !_vm.disabled,
                disabled: _vm.disabled || _vm.inactive,
                "tk-id": _vm.trackingIdentifier
              },
              on: { click: _vm.redirectToOutSide }
            },
            [
              _vm.icon ? _c("v-icon", [_vm._v(_vm._s(_vm.icon))]) : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "hub-header-item-title" }, [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hub-header-item-title short" }, [
                _vm._v("\n      " + _vm._s(_vm.shortTitle) + "\n    ")
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-623841ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623841ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hub/HeaderItem.vue
// module id = null
// module chunks = 